import React from 'react';

export default function ProfileContent({ teacherData }) {

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-8">Profilim</h1>
      
      <div className="bg-white rounded-lg shadow p-6">
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Kişisel Bilgiler</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InfoField label="Ad Soyad" value={teacherData?.adi} />
            <InfoField label="E-posta" value={teacherData?.e_posta} />
            <InfoField label="IBAN" value={teacherData?.iban || '-'} />
            <InfoField label="Verdiğim Dersler" value={Array.isArray(teacherData?.ders) ? teacherData.ders.join(', ') : (teacherData?.ders || '-')} />
          </div>
        </div>
        
        <hr className="my-6" />
        
        <div>
          <h2 className="text-xl font-semibold mb-4">İletişim Bilgileri</h2>
          
          <div className="space-y-4">
            <InfoField label="Telefon" value={teacherData?.telefon || '-'} />
            <InfoField label="Telefon 2" value={teacherData?.teltwo || '-'} />
            <InfoField label="Adres" value={teacherData?.adres || '-'} />
          </div>
        </div>
      </div>
    </div>
  );
}

// Info Field Component
function InfoField({ label, value }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <p className="p-2 bg-gray-100 rounded">{value}</p>
    </div>
  );
}

